import { FC, memo } from 'react'
import { Tag, Text, VStack } from '../index'

export interface PhoneSpecsProps {
  memory: string
  name: string
  brand: string
}

export const PhoneSpecs: FC<PhoneSpecsProps> = memo(({ name, brand, memory }) => (
  <VStack fontSize="sm" alignItems="flex-start" spacing={1.5}>
    <Tag color="green.500" fontWeight="bold" fontSize="xxs" backgroundColor="lightGreen">
      {memory}
    </Tag>
    <Text fontWeight="700" fontSize="xs">
      {name}
    </Text>
    <Text fontSize="xxs" color="darkgray" fontWeight="bold">
      {brand}
    </Text>
  </VStack>
))
